import React, { ReactElement } from 'react'
import styled from 'styled-components'

interface FieldsProps {
    isEditor: boolean
    changeConfig: (field: string, value: unknown, sideEffects?: Record<string, boolean>) => void
    widgetConfig: GridConfig
    children?: ReactElement | Array<ReactElement>
}

export default function Fields(props: FieldsProps): ReactElement {
    return (
        <FieldsetWrapper>
            {React.Children.map(props.children, function (children) {
                const Field = children?.type
                const configField: string = children?.props.configField

                if (children?.props.editorOnly && !props.isEditor) {
                    return null
                }
                if (typeof children?.props.skipOn === 'function' && children?.props.skipOn(props.widgetConfig)) {
                    return null
                }

                function updateValue(value: unknown, updateQuery?: boolean): void {
                    if (props.changeConfig) {
                        props.changeConfig(
                            configField,
                            value,
                            updateQuery && props.isEditor
                                ? undefined
                                : {
                                      updateQuery: updateQuery
                                  }
                        )
                    }
                }
                if (String(Field).startsWith('styled.')) {
                    return children
                }

                return (
                    <FieldWrapper>
                        <Field
                            className={props.isEditor ? '' : ' dropdown-toggler--cancel-drag'}
                            {...children.props}
                            value={(props.widgetConfig || {})[configField]}
                            defaultValue={children.props.defaultValue}
                            widgetConfig={props.widgetConfig}
                            onChange={updateValue}
                            isEditor={props.isEditor}
                            changeConfig={props.changeConfig}
                        />
                    </FieldWrapper>
                )
            })}
        </FieldsetWrapper>
    )
}

const FieldsetWrapper = styled.div`
    padding: 13px 0 0 0;
    margin-bottom: 10px;
`

const FieldWrapper = styled.div`
    margin: 0 10px 0;
`
